
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import useLocale from 'next-translate/useTranslation';
import Seo from '@/components/Seo';
import DashboardLayout from '@/components/layout/DashboardLayout';
import ImageToolsGrid from '@/components/images/ImageToolsGrid';
export default function ImageTools() {
    const { t } = useLocale('ai-images');
    return (<DashboardLayout>
      <Seo title={t('AI Image Tools | Easy-Peasy.AI')} description={t('Enhance your creations with our AI image tools')}/>
      <main className='flex-1 overflow-y-auto p-8 focus:outline-none'>
        <div className='mb-10'>
          <h1 className='text-3xl font-bold text-gray-900 dark:text-white'>
            {t('AI Image Tools')}
          </h1>
          <p className='mt-2 text-gray-600 dark:text-gray-300'>
            {t('Enhance your creations with our AI tools')}
          </p>
        </div>

        <ImageToolsGrid />
      </main>
    </DashboardLayout>);
}

    async function __Next_Translate__getStaticProps__1a11b03d013__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/image-tools',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a11b03d013__ as getStaticProps }
  